var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarca(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62,
    height: 24,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.32,
    style: {
      mixBlendMode: "luminosity"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M25.117 17.997c-.098 0-.161-.064-.144-.161l1.384-8.686c.017-.097.08-.16.178-.16h3.064c.098 0 .161.063.144.16l-1.384 8.686c-.017.097-.08.16-.178.16zm5.206-5.871-.618 3.886a.168.168 0 0 0 .165.194h3.992c.088 0 .156.08.143.17l-.228 1.447a.152.152 0 0 0 .148.174H36.8l.263-1.642a.17.17 0 0 1 .169-.144h.715a.17.17 0 0 0 .17-.144l.38-2.388a.15.15 0 0 0-.148-.173h-.656a.15.15 0 0 1-.148-.174l.182-1.138a.168.168 0 0 0-.165-.195h-2.722a.15.15 0 0 0-.148.127l-.199 1.253a.154.154 0 0 1-.148.127h-.724c-.11 0-.186-.119-.13-.216l3.207-6.247a.198.198 0 0 0-.177-.288h-3.353a.2.2 0 0 0-.177.11l-2.582 5.024a.7.7 0 0 0-.085.237m13.202-.584c.423 0 1.07.08 1.718.195.047.017.115 0 .131-.047l.521-2.32c0-.046 0-.063-.063-.097-.339-.178-1.88-.275-2.625-.275-2.188 0-3.97.39-3.97 3.306 0 .681.178 1.215 1.134 1.799 1.101.681 1.169.745 1.169.973 0 .339-.144.406-.699.406-.406 0-1.07-.063-1.765-.194-.063-.017-.097 0-.114.034l-.584 2.235c0 .063.017.097.08.114.584.178 1.994.326 2.917.326 2.526 0 3.809-.86 3.809-3.192 0-.715-.258-1.265-1.249-1.879-1.003-.63-1.117-.762-1.117-.99-.004-.246.093-.394.707-.394m9.337 6.048c.097-.034.131-.08.131-.143l.098-2.108c0-.047-.047-.08-.132-.064-.503.098-1.54.229-2.188.229-1.168 0-1.57-.161-1.57-.648 0-.178.017-.241.097-.241l3.094-.339c.648-.063 1.152-.292 1.38-.893.114-.309.258-1.07.258-1.701 0-1.765-1.117-2.675-3.276-2.675-1.231 0-2.268.16-3.064.778-1.38 1.054-1.816 3.471-1.816 5.025 0 2.366 1.426 3.191 4.004 3.191 1.139-.004 2.37-.199 2.984-.41m-3.11-6.129c.16-.211.389-.309.744-.309.55 0 .698.356.698.682 0 .258-.046.567-.097.728-.046.16-.097.195-.195.195H49.51c-.047 0-.097-.017-.097-.08-.005-.356.11-.923.338-1.216m7.779.212c.876 0 1.1.098 1.1.356 0 .017 0 .063-.017.144l-.033.211c-.017.064-.047.08-.115.098l-1.46.194c-1.266.161-2.125.356-2.624 1.003-.373.47-.567 1.296-.567 2.286 0 1.49.905 2.027 4.004 2.027 1.667 0 3.145-.291 3.208-.647l.906-5.77c.034-.16.046-.406.046-.55 0-1.523-1.282-2.027-3.11-2.027-1.088 0-2.807.241-3.438.423-.114.034-.143.132-.143.229l-.23 2.171c0 .064.064.114.132.098.491-.085 1.727-.246 2.34-.246m.618 4.135c-.017.161-.047.212-.178.212-.923 0-1.1-.144-1.1-.55 0-.356.063-.745.194-.957.144-.241.504-.326.99-.326h.212c.064 0 .115.034.115.08v.018zM26.827 6.18l-.305 1.913a.13.13 0 0 0 .127.153h3.065a.204.204 0 0 0 .199-.17l.304-1.913a.13.13 0 0 0-.127-.152h-3.064a.204.204 0 0 0-.2.17m6.582 7.246 3.305-6.433Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M3.801 9.807A6.003 6.003 0 0 1 11.995 12a5.995 5.995 0 0 0 8.195 2.192 5.994 5.994 0 0 0 2.192-8.194A11.99 11.99 0 0 0 11.996 0C5.371 0 0 5.371 0 11.995c0 2.185.584 4.233 1.604 5.998-1.655-2.861-.673-6.527 2.197-8.186"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M21.68 19.052c.016-.021-.018-.046-.035-.025a6.01 6.01 0 0 1-7.453 1.172 5.996 5.996 0 0 1-2.201-8.19s0-.004.004-.004l-.076-.123C10.192 9.148 6.602 8.195 3.8 9.812a6 6 0 0 0-2.192 8.19A11.99 11.99 0 0 0 11.995 24c3.987 0 7.504-1.951 9.684-4.948"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "m1.603 18.002-.055-.093c-.034-.063-.093-.148-.157-.275a5.8 5.8 0 0 1-.474-1.109 6.2 6.2 0 0 1-.296-1.87 6.383 6.383 0 0 1 .474-2.46c.36-.863.94-1.748 1.782-2.48.102-.093.216-.178.326-.271q.083-.064.174-.127l.088-.064.026-.017.008-.008.021-.013.043-.025.16-.11c.056-.038.132-.076.195-.115.136-.08.267-.143.398-.215a6.5 6.5 0 0 1 .843-.356c.143-.055.296-.093.448-.14.153-.038.305-.08.462-.105a7 7 0 0 1 3.949.38c.651.259 1.265.64 1.828 1.097a7.4 7.4 0 0 1 1.44 1.638 4.64 4.64 0 0 0 1.968 1.634 5.3 5.3 0 0 0 2.4.461c.402-.013.8-.085 1.18-.195.093-.03.19-.055.284-.093l.14-.05.135-.06.034-.013.017-.008.008-.004-.02.012.084-.042c.06-.03.118-.055.173-.085.08-.042.148-.067.233-.118a5.44 5.44 0 0 0 1.714-1.503 5.1 5.1 0 0 0 .88-1.896c.149-.635.162-1.223.12-1.714a10 10 0 0 0-.174-1.156c-.021-.14-.051-.245-.064-.317q-.019-.109-.02-.11s.016.034.05.093c.034.063.089.152.148.28.123.245.292.617.428 1.117.13.5.228 1.126.186 1.845a6.1 6.1 0 0 1-.606 2.324 6 6 0 0 1-.744 1.16 5.8 5.8 0 0 1-1.071 1.015 6.2 6.2 0 0 1-1.363.762c-.25.098-.504.187-.77.25-.132.038-.267.06-.403.089-.135.021-.27.047-.41.06a6.05 6.05 0 0 1-5.88-2.971 5.94 5.94 0 0 0-5.781-2.951c-.136.008-.271.038-.407.055-.13.025-.266.05-.398.084a6 6 0 0 0-.761.242 6.1 6.1 0 0 0-1.35.749c-.403.3-.763.639-1.063 1.003a5.963 5.963 0 0 0-1.359 3.454 5.9 5.9 0 0 0 .584 2.963c.055.127.11.216.144.28.034.058.051.092.051.092"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 43.479,
    x2: 43.479,
    y1: 17.995,
    y2: 8.332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B63AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#147CC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#1894D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.684,
    stopColor: "#1FA6DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.868,
    stopColor: "#23B2E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25B6EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 3.654,
    x2: 17.475,
    y1: 3.377,
    y2: 17.198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D4D91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.027,
    stopColor: "#0A5294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.216,
    stopColor: "#0E6DAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.399,
    stopColor: "#1086BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574,
    stopColor: "#109CD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.736,
    stopColor: "#12ACE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.883,
    stopColor: "#12B7EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11BAEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 11.241,
    x2: 11.241,
    y1: 24.466,
    y2: 10.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#11BAEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.055,
    stopColor: "#1CABDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.408,
    stopColor: "#286795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.693,
    stopColor: "#233D6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.897,
    stopColor: "#1F235A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E1853"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: -0.001,
    x2: 23.983,
    y1: 12.003,
    y2: 12.003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09C3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.264,
    stopColor: "#7BD3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.612,
    stopColor: "#C3E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867,
    stopColor: "#ECF8FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarca);
export default __webpack_public_path__ + "static/media/marca.c2b98ce0fa823b416a64be43df604300.svg";
export { ForwardRef as ReactComponent };